import "./LoadingView.scss";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectText } from "../../../translation/translationSlice";
import {
  selectLoading,
  selectLoaded,
  start,
  selectLoadingProgress,
} from "../../../three/threeSlice";
import ValtraLoadingButton from "../ValtraLoadingButton";
import { series } from "../../../../data";

function LoadingView({ children }) {
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const loadingProgress = useSelector(selectLoadingProgress);
  const loaded = useSelector(selectLoaded);
  const t = useSelector(selectText);
  const [hide, setHide] = useState(false);

  useEffect(() => {
    if (loaded) {
      setTimeout(() => {
        setHide(true);
      }, 500);
    }
  }, [loaded]);

  return (
    <div
      className={
        "LoadingView" + (loaded ? " loaded" : "") + (hide ? " hide" : "") + ` ${series}`
      }
    >
      <div className="LoadingView-inner">
        <h1>{t("ui-app-name")}</h1>
        <ValtraLoadingButton
          label={!loading && !loaded ? t("ui-start") : t("ui-loading")}
          loading={loading}
          loaded={loaded}
          loadingProgress={loadingProgress < 1 ? loadingProgress * 0.75 : 1}
          onClick={(e) => dispatch(start())}
        />
      </div>
    </div>
  );
}

export default LoadingView;
